module.exports = __webpack_public_path__ + "static/media/Logo.c62fd2de.png";